import { Actor } from "./actor";
import { Text } from "./text";

export class Npc extends Actor {
  private npcBanner: Text;
  avatar_id = "";

  constructor(
    scene: Phaser.Scene,
    avatar_id: string,
    name: string,
    x: number,
    y: number,
  ) {
    super(scene, x, y, `${avatar_id}`);
    this.avatar_id = avatar_id;
    this.npcBanner = new Text(
      this.scene,
      this.x,
      this.y - this.height,
      name,
    ).setFontSize(14);
    this.npcBanner.setPosition(this.x, this.y - this.height * 0.45);
    this.npcBanner.setOrigin(0.5, 0.5);
    // Animate
    this.initAnimations();
    this.anims.play(`a-npc-${this.avatar_id}-idle`, true);
  }

  update(): void {
    this.npcBanner.setPosition(this.x, this.y - this.height * 0.45);
    this.npcBanner.setOrigin(0.5, 0.5);
  }

  private initAnimations(): void {
    this.scene.anims.create({
      key: `a-npc-${this.avatar_id}-idle`,
      frames: this.scene.anims.generateFrameNames(`a-npc-${this.avatar_id}`, {
        prefix: `idle-`,
        end: 5,
      }),
      frameRate: 8,
      repeat: -1,
    });
  }
}
